/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { url } from '../../../shared/utils/url';
import useAxios from '../../../shared/hooks/use-axios';
import { useSelector } from 'react-redux';
import Banner from '../../../components/common/form/Banner';
import CorporateBanner from '../../../components/common/form/CorporateBanner';
import PageLoader from '../../../components/common/layout/PageLoader';
import { Helmet } from 'react-helmet';
import { sitemap } from '../../../shared/utils/sitemap';
import Error from '../../../components/common/form/Error';
import Canonical from '../../../components/common/layout/Canonical';

const Content = ({ type }: any) => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false)
    const params = useParams();
    const navigate = useNavigate();

    const getPageContentData = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + (type === "passenger" ? url?.pages : url?.corporate_pages) + params?.slug}/`);
            if (res && res?.status === 200) {
                if (res?.data?.length === 0) {
                    setData(res?.data?.[0]);
                    (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
                } else {
                    setData(res?.data?.[0]);
                    sitemap()
                }
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            console.error("error while feching page content data", error);
        }
    };

    useEffect(() => {
        (!!lang && !!params?.slug) && getPageContentData()
    }, [lang, params?.slug])

    return (
        <>
            <Canonical />
            {(!!data?.search_description || !!data?.seo_title) && <Helmet>
                {!!data?.seo_title && <title>{data?.seo_title}</title>}
                {!!data?.search_description && <meta name="description" content={data?.search_description} />}
            </Helmet>}
            <div className='bg-white dark:bg-bgDarkDull'>
                {type === "passenger" ? <Banner title={data?.title} root1={data?.subtitle} root2={data?.title} /> : <CorporateBanner title={data?.title} root1={data?.subtitle} root2={data?.title} data={data} />}
                <div id="home">
                    {loading ?
                        <PageLoader />
                        :
                        <>
                            {isError ?
                                <div className={`${type === "corporate" ? "mb-[30px] lg:mb-[50px]" : ""}`}>
                                    <Error />
                                </div>
                                : <>
                                    <div dangerouslySetInnerHTML={{ __html: data?.content }} />
                                </>}
                        </>}
                </div >
            </div >
        </>
    );
};

export default Content;